import { funnelHref } from "@/lib/site";

const COURSES = {
  llm: { step: 1, title: "LLM Foundations", line: "Make the AI landscape understandable, then connect it to a problem you already know." },
  prompt: { step: 2, title: "Prompt Engineering with LLMs", line: "Stop guessing with prompts. Learn to design AI tasks you can test, trust and explain." },
  agentic: { step: 3, title: "Agentic AI Engineering", line: "An agent is not a model with a clever prompt. Learn to build, test and run agentic systems properly." },
};

const RULES = [
  ["agentic", /\bagentic\b|\bai agents?\b|multi-agent|\bagents? (engineer|developer|builder)|llmops|mlops|autonomous (ai|systems?)|ai platform|ai automation/i],
  ["prompt", /prompt|gen\s?ai|generative|\bllms?\b|\brag\b|chatbot|conversational ai|ai (application|app|developer|engineer|solutions?)/i],
  ["llm", /\bai\b|artificial intelligence|machine learning|\bml\b|data scien|deep learning|\bnlp\b/i],
];

export const matchCourse = (role = "") => RULES.find(([, re]) => re.test(role))?.[0] || null;

export const CourseMatch = ({ role }) => {
  const key = matchCourse(role);
  if (!key) return null;
  const c = COURSES[key];
  return (
    <section data-testid="studio-course-match" style={{ marginTop: 28, background: "#0b1f1d", color: "#fff", padding: "26px 28px", display: "grid", gap: 18, gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", alignItems: "center" }}>
      <div>
        <p style={{ fontSize: 12, fontWeight: 800, letterSpacing: ".12em", color: "#7fd4c9", margin: 0 }}>BUILD THE EVIDENCE THIS ROLE ASKS FOR</p>
        <h3 data-testid="studio-course-title" style={{ font: "500 28px/1.15 Georgia", margin: "8px 0 6px" }}>{c.title}</h3>
        <p style={{ fontSize: 15, color: "#d6e4e1", margin: 0 }}>{c.line}</p>
        <p style={{ fontSize: 13, color: "#b9cbc7", marginTop: 10 }}>Step {c.step} of 3 in the Art of Resume AI pathway, matched to your target role “{role}”. Each course includes hands-on labs you can turn into evidence on this resume.</p>
      </div>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", justifyContent: "flex-start" }}>
        <a href={funnelHref(`/courses/${key}`)} data-testid="studio-course-link" style={{ background: "#fff", color: "#0b1f1d", padding: "12px 18px", fontWeight: 800, fontSize: 14 }}>View the curriculum →</a>
        <a href={funnelHref("/#pathway")} data-testid="studio-pathway-link" style={{ border: "1px solid #ffffff66", color: "#fff", padding: "12px 18px", fontWeight: 700, fontSize: 14 }}>See all 3 steps</a>
      </div>
    </section>
  );
};
